import { useAppDispatch, useAppSelector } from "@/state/redux/hooks";
import { useSidebar } from "../sidebar";
import { useEffect } from "react";
import {
  requestOpenTimeSidebar,
  selectTimeSidebarRequested,
} from "@/state/redux/slices/ui";

/**
 * Opens the time sidebar when something outside it asks.
 *
 * Must live inside that sidebar's own SidebarProvider — `useSidebar()` reads
 * the nearest context, and the two sidebars have one each.
 */
export default function TimeSidebarController() {
  const dispatch = useAppDispatch();
  const { setOpenMobile } = useSidebar();
  const requested = useAppSelector(selectTimeSidebarRequested);

  useEffect(() => {
    if (requested) {
      setOpenMobile(true);
      // One-shot: clear the request so the next one is seen as a new edge.
      dispatch(requestOpenTimeSidebar(false));
    }
  }, [requested, setOpenMobile, dispatch]);

  return null;
}
